export var GLOBAL = {
    url: 'https://api.carmen.com.ar/api/',
    url2: 'https://api.carmen.com.ar/',
    //url: 'http://localhost:4201/api/', //CAMBIAR  
    //url2: 'http://localhost:4201/',  
}